import type { Tag } from '@sats-group/ui-lib/react/tag/tag.types';
import type { ValueOf } from 'type-fest';
import type { ImageMedia, RawSvgMedia } from '~/shared/media-type-helper';
import type { Indicator } from '../indicator/indicator.types';

export const themes = {
  promotionalFixed: 'promotional-fixed',
  standardPrimary: 'standard-primary',
  standardSecondary: 'standard-secondary',
} as const;

export const aspectRatios = {
  fourSix: 'aspect-ratio-4-6',
  fourFive: 'aspect-ratio-4-5',
  oneOne: 'aspect-ratio-1-1',
} as const;

export type PreviewCard = {
  aspectRatio?: ValueOf<typeof aspectRatios>;
  href: string;
  image: ImageMedia | RawSvgMedia;
  indicator?: Indicator;
  indicatorLabel?: string;
  tags: Tag[];
  /**
   * note: the component actually does not need `tall` property,
   * but Component list requires it, we might consider using this field
   * as indicator about the aspect ratio instead
   */
  tall?: boolean;
  text?: string;
  theme?: ValueOf<typeof themes>;
  title: string;
};
